import axios from 'axios';

const defaultHeaders = {
  'Content-Type': 'application/json'
};

class AxiosClass {
  constructor(baseURL) {
    this.Axios = axios.create({
      baseURL,
      timeout: 100000,
      headers: defaultHeaders
    });
    this.setUpInterceptors();
  }

  setUpInterceptors = () => {
    this.Axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const errorMessage = 'An error occurred while processing your request.';

        if (error.response) {
          // Extract the message from the API response
          error.message = error.response.data?.message || errorMessage;
        } else if (error.request) {
          // Handle no response scenario
          error.message = 'No response received from the server.';
        }

        return Promise.reject(error);
      }
    );

    this.Axios.interceptors.request.use(
      (request) => {
        const token = JSON.parse(window.localStorage.getItem('okta-token-storage'))?.accessToken
          ?.accessToken;
        if (token) {
          request.headers.Authorization = `Bearer ${token}`;
        }
        return request;
      },
      (error) => Promise.reject(error)
    );
  };

  getRequest = async (url, params = {}) => {
    return this.Axios.get(url, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response.data);
  };

  getRequestWithData = async (url, params = {}) => {
    return this.Axios.get(url, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response);
  };

  postRequest = async (url, data, params = {}) => {
    return this.Axios.post(url, data, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response.data);
  };

  deleteRequest = async (url, params = {}) => {
    return this.Axios.delete(url, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response.data);
  };

  putRequest = async (url, data = {}, params = {}) => {
    return this.Axios.put(url, data, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response.data);
  };

  patchRequest = async (url, data, params = {}) => {
    return this.Axios.patch(url, data, {
      ...params,
      headers: { ...defaultHeaders, ...params.headers }
    }).then((response) => response.data);
  };
}

export default AxiosClass;
